export const ENDPOINTS = {
  organization: (organizationId) => `/organization/${organizationId}`,
  track: '/library/track'
};
